export const GET_PLACE__REQUEST = 'GEO_TYPE__GET_PLACE__REQUEST'
export const GET_PLACE__SUCCESS = 'GEO_TYPE__GET_PLACE__SUCCESS'
